import { Button, Dialog, Modal } from 'alurkerja-ui';
import { OutlineButton } from '@/components/shared/button/OutlineButton';
import { MdCloudUpload } from 'react-icons/md';
import { UploadField } from '@/components/form/fields/UploadField';
import { FormContainer } from '@/components/form/FormContainer';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import {
  IImportFileSchema,
  importFileSchema,
  TestPlanService,
} from '@/api/testPlan';

type ImportTestPlanProps = {
  id?: string;
};

export const ImportTestPlan: React.FC<ImportTestPlanProps> = ({ id }) => {
  const form = useForm<IImportFileSchema>({
    resolver: zodResolver(importFileSchema),
  });

  const { mutate: importMutate, isPending: isImportLoading } =
    TestPlanService.useImport(id!);

  const submitAction = (data: IImportFileSchema) => {
    importMutate(data, {
      onSuccess: () => {
        Dialog.success({
          title: 'Berhasil',
          description: 'Berhasil Import Test Plan',
          callback: () => window.location.reload(),
        });
      },
      onError: () => {
        Dialog.error({
          title: 'Gagal',
          description: 'Gagal Import Test Plan',
        });
      },
    });
  };
  return (
    <Modal
      title="Import Test Plan"
      maxWidth={'3xl'}
      triggerButton={
        <OutlineButton icon={<MdCloudUpload />}>Import</OutlineButton>
      }
    >
      <div className="m-5">
        <FormContainer form={form} onSubmit={submitAction}>
          <UploadField
            name="file"
            label="Attachments"
            note="Allowed Formats: xlsx"
            type="file"
            allowedExtensions={['xlsx']}
            hasRequiredAsterisk
          />
          <Button className="mt-3" loading={isImportLoading}>
            Import
          </Button>
        </FormContainer>
      </div>
    </Modal>
  );
};
